import { useEffect, useRef, useState } from "react";
import { ManageEntryRow } from "./ManageEntryRow";
import { T } from "../../util/t";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { Checkbox } from "../forms/fields/Checkbox";
import { Box } from "@mui/material";
import { Check, Remove } from "@mui/icons-material";
import { BulkConfirmButton } from "./BulkConfirmButton";
import { EntriesMenu } from "./EntriesMenu";
import { useBulkSelection } from "../../../hooks/useBulkSelection";

export const ManageEntriesTableContent = ({
    entries,
    confirmed,
    showBibs,
    isAlternates,
    isTeams,
    showSeeds,
    seedIsPosition,
    statusTitle,
    updateFailedPayments,
    clearFailedPayments,
    teamRoles,
}) => {
    const isMobile = useIsMobile();
    const entriesUnconfirmedRef = useRef(false);
    const [hasUnconfirmedEntries, setHasUnconfirmedEntries] = useState(false);
    const { selectedItems, toggleSelectedItems, toggleAllItems } =
        useBulkSelection(entries);
    const [bulkSelectEnabledForMobile, setBulkSelectEnabledForMobile] =
        useState(false);

    useEffect(() => {
        if (!entriesUnconfirmedRef.current) {
            entriesUnconfirmedRef.current = entries.some(
                (entry) =>
                    (entry.status === "waitlisted" &&
                        (!entry.payment || entry.payment.status === "setup")) ||
                    entry.status === "registered",
            );
            setHasUnconfirmedEntries(entriesUnconfirmedRef.current);
        }
    }, [entries]);

    return (
        <>
            <thead>
                <tr>
                    {hasUnconfirmedEntries &&
                        (!isMobile || bulkSelectEnabledForMobile) && (
                            <th>
                                <Box
                                    component="span"
                                    paddingX={{ lg: 1, md: 0 }}
                                >
                                    <Checkbox
                                        input={{
                                            onChange: toggleAllItems,
                                            value: selectedItems.length > 0,
                                        }}
                                        Icon={
                                            selectedItems.length ===
                                            entries.length
                                                ? Check
                                                : Remove
                                        }
                                    />
                                </Box>
                            </th>
                        )}
                    <th colSpan={showBibs ? 2 : 1}>
                        {isAlternates ? (
                            <T>Cancellations</T>
                        ) : !(
                              selectedItems.length === 0 ||
                              !hasUnconfirmedEntries
                          ) ? (
                            <BulkConfirmButton
                                entries={selectedItems}
                                updateFailedPayments={updateFailedPayments}
                                clearFailedPayments={clearFailedPayments}
                            />
                        ) : isTeams ? (
                            <T>Team</T>
                        ) : (
                            <T>Athlete</T>
                        )}
                    </th>
                    {showSeeds && (
                        <Box component="th" paddingRight={2}>
                            {seedIsPosition ? (
                                isMobile ? (
                                    <T>Pos.</T>
                                ) : (
                                    <T>Position</T>
                                )
                            ) : (
                                <T>Seed</T>
                            )}
                        </Box>
                    )}

                    <th colSpan={2}>
                        <Box
                            component="div"
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            <T>{statusTitle}</T>
                            {hasUnconfirmedEntries && isMobile && (
                                <EntriesMenu
                                    bulkSelectEnabled={
                                        bulkSelectEnabledForMobile
                                    }
                                    setBulkSelectEnabled={
                                        setBulkSelectEnabledForMobile
                                    }
                                />
                            )}
                        </Box>
                    </th>
                    {!isMobile && <th />}
                </tr>
            </thead>
            <tbody>
                {entries.map((entry, index) => (
                    <ManageEntryRow
                        key={entry.id}
                        entry={entry}
                        highlight={confirmed !== entries.length}
                        showBib={showBibs}
                        isTeams={isTeams}
                        showSeed={showSeeds}
                        seedIsPosition={seedIsPosition}
                        isMobile={isMobile}
                        selected={selectedItems.some((e) => e.id === entry.id)}
                        toggleEntries={toggleSelectedItems}
                        bulkSelectEnabledForMobile={bulkSelectEnabledForMobile}
                        hasUnconfirmedEntries={hasUnconfirmedEntries}
                        teamRoles={teamRoles}
                        index={index}
                    />
                ))}
            </tbody>
        </>
    );
};
